export default {
  title: "Dangerous Items",
  subtitle: "Manage dangerous items",
  
  breadcrumbs: {
    dangerousItems: "Dangerous Items"
  },
  
  table: {
    name: "Name",
    price: "Price",
    actions: "Actions"
  },
  
  actions: {
    add: "Add New Item",
    edit: "Edit",
    delete: "Delete",
    refresh: "Refresh",
    export: "Export",
    search: "Search dangerous items...",
    filter: "Filter"
  },
  
  messages: {
    fetchError: "Error fetching dangerous items",
    deleteSuccess: "Item deleted successfully",
    deleteError: "Error deleting item",
    deleteConfirm: "Are you sure you want to delete this item?",
    noItems: "No items found",
    loading: "Loading dangerous items..."
  },
  
  form: {
    name: "Item Name",
    price: "Price",
    description: "Description",
    category: "Category",
    status: "Status"
  },
  
  placeholders: {
    name: "Enter item name",
    price: "Enter price",
    description: "Enter description",
    search: "Search by name or price..."
  },
  
  validation: {
    nameRequired: "Item name is required",
    priceRequired: "Price is required",
    invalidPrice: "Please enter a valid price",
    negativePrice: "Price cannot be negative",
    fillAllFields: "Please fill in all required fields"
  },
  
  status: {
    active: "Active",
    inactive: "Inactive"
  }
};
